import utilities from '@/services/utilities/utilities';

export default {
  validateBeforeEquityCalculatorSimulation: function (players, presetCommunityCards) {
    let validatePlayerRangesNotEmptyResult;
    let validatePresetCommunityCardsResult;

    validatePlayerRangesNotEmptyResult = this._validateEquityCalculatorPlayerRangesNotEmpty(players);
    if (validatePlayerRangesNotEmptyResult.error) {
      return {
        error: true,
        errorMessage: validatePlayerRangesNotEmptyResult.errorMessage
      };
    }

    validatePresetCommunityCardsResult = this._validatePresetCommunityCards(presetCommunityCards);
    if (validatePresetCommunityCardsResult.error) {
      return {
        error: true,
        errorMessage: validatePresetCommunityCardsResult.errorMessage
      };
    }

    return {
      error: false
    };
  },
  validateBeforeHitCalculatorSimulation: function (players, presetHoleCards, presetCommunityCards) {
    let validatePresetHoleCardsResult;
    let validatePresetCommunityCardsResult;
    let validatePlayerRangesNotEmptyResult;

    validatePresetHoleCardsResult = this._validatePresetHoleCards(presetHoleCards);
    if (validatePresetHoleCardsResult.error) {
      return {
        error: true,
        errorMessage: validatePresetHoleCardsResult.errorMessage,
      };
    }

    validatePresetCommunityCardsResult = this._validatePresetCommunityCards(presetCommunityCards);
    if (validatePresetCommunityCardsResult.error) {
      return {
        error: true,
        errorMessage: validatePresetCommunityCardsResult.errorMessage,
      };
    }

    validatePlayerRangesNotEmptyResult = this._validateHitCalculatorPlayerRangesNotEmpty(players, presetCommunityCards);
    if (validatePlayerRangesNotEmptyResult.error) {
      return {
        error: true,
        errorMessage: validatePlayerRangesNotEmptyResult.errorMessage,
      };
    }

    return {
      error: false
    };
  },
  _validateEquityCalculatorPlayerRangesNotEmpty: function (players) {
    let error = false;
    let errorMessage = '';

    if (players.hasEmptyRange('preflop')) {
      error = true;
      errorMessage = 'One or more player range is empty.';
    }

    return {
      error: error,
      errorMessage: errorMessage,
    };
  },
  _validatePresetHoleCards: function (presetHoleCards) {
    let error = false;
    let errorMessage = '';
    let holeCardOneSet = !!presetHoleCards.holeCardOne;
    let holeCardTwoSet = !!presetHoleCards.holeCardTwo;

    if (holeCardOneSet && !holeCardTwoSet) {
      error = true;
      errorMessage = 'You forgot to set the second hole card.';
    }

    else if (!holeCardOneSet && holeCardTwoSet) {
      error = true;
      errorMessage = 'You forgot to set the first hole card.';
    }

    return {
      error: error,
      errorMessage: errorMessage
    };
  },
  _validatePresetCommunityCards: function (presetCommunityCards) {
    let error = false;
    let errorMessage = '';

    if (presetCommunityCards.river && (!presetCommunityCards.turn || !presetCommunityCards.flop3 || !presetCommunityCards.flop2 || !presetCommunityCards.flop1)) {
      error = true;
      errorMessage = 'You can\'t set the river without setting the flop and turn.';
    }

    if (presetCommunityCards.turn && (!presetCommunityCards.flop3 || !presetCommunityCards.flop2 || !presetCommunityCards.flop1)) {
      error = true;
      errorMessage = 'You can\'t set the turn without setting the flop.';
    }

    if (presetCommunityCards.flop3 && (!presetCommunityCards.flop2 || !presetCommunityCards.flop1)) {
      error = true;
      errorMessage = 'You can\'t set the third community card without setting the first two.';
    }

    if (presetCommunityCards.flop2 && !presetCommunityCards.flop1) {
      error = true;
      errorMessage = 'You can\'t set the second community card without setting the first.';
    }

    return {
      error: error,
      errorMessage: errorMessage
    };
  },
};



// WEBPACK FOOTER //
// ./src/services/simulator/validator.js